/*
  PodHub Custom Storefront Layer
  Private JS namespace for Locena / POD storefront.
*/

window.PodHubTheme = window.PodHubTheme || {};
window.PodHubTheme.version = '1.0.1';

window.PodHubTheme.cleanPriceLabels = function () {
  const targets = document.querySelectorAll(
    '.price, .price__container, .price__sale, .price__regular, .card-information, .card__information, .product-card'
  );

  targets.forEach(function (target) {
    const walker = document.createTreeWalker(
      target,
      NodeFilter.SHOW_TEXT,
      null
    );

    const textNodes = [];
    while (walker.nextNode()) {
      textNodes.push(walker.currentNode);
    }

    textNodes.forEach(function (node) {
      node.textContent = node.textContent
        .replace(/\bFrom\s+/gi, '')
        .replace(/\bFrom\b/gi, '');
    });
  });
};

window.PodHubTheme.init = function () {
  document.documentElement.classList.add('podhub-theme-ready');
  window.PodHubTheme.cleanPriceLabels();

  setTimeout(window.PodHubTheme.cleanPriceLabels, 300);
  setTimeout(window.PodHubTheme.cleanPriceLabels, 1000);
};

document.addEventListener('DOMContentLoaded', window.PodHubTheme.init);
document.addEventListener('shopify:section:load', window.PodHubTheme.cleanPriceLabels);

const podhubObserver = new MutationObserver(function () {
  window.PodHubTheme.cleanPriceLabels();
});

document.addEventListener('DOMContentLoaded', function () {
  podhubObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
});
